import React, { Component } from 'react';
import serverApi from "../../api/Common";
import '../../App.css';
import './LoginForm.css';
import Loader from "../../Loader/Loader";
import Alert from "../../Alert/Alert";



class LoginForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            passwd: '',
            btn: false,
            error: "",
            showError: false,
            ajax: false,
            errorField: false,
            errorFieldMessage: "",
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        let state = this.state;
        state[name] = value;
        this.validate();
    }

    handleSubmit(event) {
        const st = this.state;
        const inst = this;
        this.setState({ajax: true, errorField: false});
        let data = {login: st.email, password: st.passwd};
        serverApi.api('login',
            data,
            function (result) {
                if (result.auth) {
                    window.location.href = '/panel.html';
                } else {
                    inst.setState({
                        errorField: true,
                        errorFieldMessage: 'Невірний логін або пароль.',
                        passwd: ''
                    });
                }
                inst.setState({ajax: false});
            },
            function (error) {
                inst.setState({
                    error: "Помилка зв'язку!",
                    showError: true,
                    ajax: false
                });
                inst.validate();

                setTimeout(function () {
                    inst.setState({
                        error: "",
                        showError: false,
                    });
                    inst.validate();
                }, 5000)
            });
        event.preventDefault();
    }

    validate() {
        let st = true;
        let state = this.state;
        let re = /^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
        if (!re.test(state.email)) {
            st = false;
        }
        if (state.passwd.length < 6) {
            st = false;
        }
        state.btn = st && !state.showError;
        this.setState(state);
    }

    componentDidMount() {
        serverApi.getStatusState(function (res) {
            if (res.auth) {
                window.location.href = '/panel.html';
            }
        });
    }

    render() {
        return (
            <div className="container login-form d-flex
                            flex-column align-items-center"
            >
                {this.state.ajax && <Loader />}

                {this.state.showError && <Alert type="danger" time={4000} message={this.state.error}/>}


                <h4 className="font-weight-bold">Вхід до кабінету</h4>
                <form className="" onSubmit={this.handleSubmit}>

                    {/*login group*/}
                    <div className="row inputField">
                        <label htmlFor="regInputEmail" className="sr-only">Ваша адреса email</label>
                        <label htmlFor="regInputEmail" className="col-form-label text-right pr-0">Логін</label>
                        <div>
                            <input name="email" type="email" id="regInputEmail"
                                   className="form-control form-input-first border-0"
                                   placeholder="Email" value={this.state.email}
                                   onChange={this.handleChange}
                                   required/>
                        </div>
                    </div>

                    {/*password group*/}
                    <div className="row inputField">
                        <label htmlFor="regInputPassword" className="sr-only">Ваш пароль для входу</label>
                        <label htmlFor="regInputPassword" className="col-form-label text-right pr-0">Пароль</label>
                        <div>
                            <input name="passwd" type="password" id="regInputPassword"
                                   className="form-control form-input-last border-0"
                                   placeholder="Пароль" value={this.state.passwd}
                                   onChange={this.handleChange} required/>
                        </div>
                    </div>

                    {this.state.errorField &&
                        <Alert type="danger" time={30000} message={this.state.errorFieldMessage}/>
                    }

                    {/*button group*/}
                    <div className="buttonGroup">
                        <button className="text-white mb-3" type="submit" disabled={!this.state.btn}>Увійти</button>
                        {/*<br/>*/}
                        {/*<a href="#">Забыл пароль?</a>*/}
                    </div>
                </form>
            </div>
        );
    }
}

export default LoginForm;



// WEBPACK FOOTER //
// ./src/Login/LoginForm/LoginForm.js